import { Button } from '@curri/components'

// The dashboard's filter control: a row of small buttons where the active one
// is filled. Lifted out of AttemptsCard when the payload history table became a
// second table filtering on the same two axes.

export const SegmentedControl = <T extends string | number>({
  ariaLabel,
  onChange,
  options,
  value,
}: {
  ariaLabel: string
  onChange: (next: T) => void
  options: { label: string; value: T }[]
  value: T
}) => (
  <div aria-label={ariaLabel} role="group" style={{ display: 'flex', gap: 4 }}>
    {options.map(option => (
      <Button
        aria-pressed={option.value === value}
        key={String(option.value)}
        label={option.label}
        onClick={() => onChange(option.value)}
        size="small"
        variant={option.value === value ? 'secondary' : 'tertiary'}
      />
    ))}
  </div>
)
